import { getPlayer } from '../../../player/playerService';

import type { Tracker, Builders, SDKConfigInput } from '@schibsted/pulse-sdk';

declare global {
  interface Window {
    pulse: any;
  }
}

interface TrackerConstructor {
  new (
    providerId: string,
    config: SDKConfigInput,
    builders?: Builders
  ): Tracker;
}

export const syncPageViewId = async (tracker: Tracker) => {
  const player = await getPlayer();

  const getTracker = async () => {
    const playerTracker = await player
      .getPlugin('PulseStats')
      ?.getTrackerOrNull();

    if (!playerTracker) {
      return;
    }

    const originalNewPageView = tracker.newPageView;

    tracker.newPageView = () => {
      originalNewPageView.call(tracker);

      playerTracker.state.pageViewId = tracker.getPageViewId();
    };
  };

  if (player.getPlugin('PulseStats')) {
    getTracker();
  } else {
    player.once('PulseStats:ready', getTracker);
  }
};

// backwards compatibility for the pulse autotracker
const externalInstances: Record<string, Tracker> = {};
export const exposePulseInstanceAsGlobal = (
  tracker: Tracker,
  PulseTracker: TrackerConstructor
) => {
  const pulseQueue: (() => void)[] = window.pulse?.q || [];
  window.pulse = (...args: any[]) => {
    if (args.length === 0) {
      return;
    }

    if (typeof args[0] === 'function') {
      args[0](tracker);
    }

    if (typeof args[0] === 'string') {
      if (args[0] === 'init') {
        const [, pulseClientId, sdkConfig, , trackerId] = args;

        externalInstances[trackerId] = new PulseTracker(pulseClientId, {
          useBeacon: true,
          useBeaconWhenAvailable: true,
          ...sdkConfig,
        });
      } else {
        const [trackerId, cb] = args;

        if (externalInstances[trackerId]) {
          cb(externalInstances[trackerId]);
        }
      }
    }
  };
  pulseQueue.forEach((fn) => {
    window.pulse.apply(null, fn);
    pulseQueue.shift();
  });
  window.pulse.q = pulseQueue;
};
